// extracted by mini-css-extract-plugin
module.exports = {"ring":"ProgressRing_ring__1E0Fy"};